module.exports = __webpack_public_path__ + "img/2024122401.e76cafcf.jpg";